var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2487 8.91602C0.742437 8.91602 0.332031 8.50561 0.332031 7.99935C0.332031 7.49309 0.742437 7.08268 1.2487 7.08268H17.7487C18.255 7.08268 18.6654 7.49309 18.6654 7.99935C18.6654 8.50561 18.255 8.91602 17.7487 8.91602H1.2487ZM1.2487 2.49935C0.742437 2.49935 0.332031 2.08894 0.332031 1.58268C0.332031 1.07642 0.742437 0.666016 1.2487 0.666016H17.7487C18.255 0.666016 18.6654 1.07642 18.6654 1.58268C18.6654 2.08894 18.255 2.49935 17.7487 2.49935H1.2487ZM1.2487 15.3327C0.742437 15.3327 0.332031 14.9223 0.332031 14.416C0.332031 13.9098 0.742437 13.4993 1.2487 13.4993H17.7487C18.255 13.4993 18.6654 13.9098 18.6654 14.416C18.6654 14.9223 18.255 15.3327 17.7487 15.3327H1.2487Z",
    fill: "#F1FAEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.3e627f2283b4b93a211fbf4112f32357.svg";
export { ForwardRef as ReactComponent };